import { AnimatePresence, motion } from 'framer-motion'
import { addOrRemoveC, SetState } from '@unimpaired/utils'
import { TableProps } from '../Table'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import React from 'react'

/**
 * We show an additional column if the row is expandable.
 * The column is just a dropdown button that expands the row
 */
export const ExpansionColumn = <T extends Record<string, any>>(props: {
  expansion: TableProps<T>['expansion']
  record: T
  isExpanded: (record: T) => boolean
  isSelected: (record: T) => boolean
  setExpandedRows: SetState<any>
}) => {
  if (!props.expansion) return null
  return (
    <td
      scope='col'
      onClick={() => props.setExpandedRows(addOrRemoveC(props.record))}
      className={`relative px-2 w-8 cursor-pointer ${
        props.isSelected(props.record) ? 'bg-base-100' : ''
      }`}>
      <FontAwesomeIcon
        icon={faChevronRight}
        className={`transform transition-all duration-300 text-base-600 ${
          props.isExpanded(props.record) ? 'rotate-90' : 'rotate-0'
        }`}
      />
    </td>
  )
}

export const ExpandedComponent = React.memo(
  (props: {
    expansion: TableProps<any>['expansion']
    isExpanded?: boolean
    children?: React.ReactNode
    key: string
  }) => {
    if (!props.expansion) return null
    if (!props.isExpanded) return null
    return (
      <AnimatePresence key={props.key}>
        <motion.tr
          initial={{ height: 0 }}
          animate={{ height: 'auto' }}
          exit={{ height: 0 }}
          transition={{ duration: 0.3 }}
          className='transition-all duration-300 transform relative overflow-hidden h-full w-full border-l-2 border-l-indigo-500'>
          <td colSpan={1000} className='bg-base-100 p-4 overflow-hidden'>
            {props.children}
          </td>
        </motion.tr>
      </AnimatePresence>
    )
  },
)
